<template>
  <span v-if="!result.isOver" class="stocks-left">
    <svg class="stocks-left__icon"><use xlink:href="#svg-watch"></use></svg>
    {{ messages.daysLeft }}
  </span>
  <span v-else class="stocks-left">
    {{ messages.over }}
  </span>
</template>

<script>
export default {
  name: 'StocksLeft',
  props: ['result', 'messages'],
};
</script>

<style lang="scss" scoped>
.stocks-left {
  display: flex;
  font-weight: 600;
  font-size: rem(12);
  line-height: 115%;
  @include point-md {
    font-size: rem(14);
    line-height: 115%;
  }
  &__icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 8px;
  }
}
</style>
